<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="12.5" cy="13" r="8.5" fill="currentColor" />
</svg>
